// extracted by mini-css-extract-plugin
export default {"wrapper":"EmptyState_wrapper__Qoxkn","icon":"EmptyState_icon__c-OfM","title":"EmptyState_title__fl4Vf","subtitle":"EmptyState_subtitle__nUaIM"};